import React from 'react';

const RadioTrance = () => (
  <div className="container mt-4">
    <h1>Trance Radio</h1>
    <p>Enjoy our Trance selection here!</p>
  </div>
);

export default RadioTrance;
